import type { LinkToMessagesSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-messages';
import { array } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';

class LinkToMessages extends Component<LinkToMessagesSignature> {
  get route(): string {
    if (this.args.category === 'discussion') {
      return 'programs.program.cohort.content.discussions';
    }
    return 'programs.program.cohort.content.announcements';
  }

  <template>
    <LinkTo
      @route={{this.route}}
      @models={{array @program.id @cohort.id}}
      ...attributes
    >
      {{yield}}
    </LinkTo>
  </template>
}

export { LinkToMessages };
